export default __webpack_public_path__ + "static/media/m-sub-banner-num-2.75940d10.svg";